<script>
  import { createEventDispatcher, onDestroy } from 'svelte';
  import FeedContainer from './components/NTB/FeedContainer.svelte';
  import ScribbleFeeds from './components/Scribble/FeedContainer.svelte';
  import { firebaseApp } from './Store/firebase-store';
  import { listenToChannel, listenToChannelIds } from './api/firebase.js';
  import { getChannelIdFromUrl } from './common/utils';
  export let app;
  export let ids = '';
  export let show = false;

  let unsubscribeListenToChannelId;
  let unsubscribeListenToChannel;
  let feedData = null;

  $: app && firebaseApp.set(app);
  $: $firebaseApp && getMappings();
  $: feedData && dispatchFeedData();
  $: ids && listenToNewChannelData(ids);

  const dispatch = createEventDispatcher();

  const dispatchFeedData = () => {
    dispatch('feedCreated', { title: feedData.title, visible: feedData.live });
  };

  const getMappings = async () => {
    if (!ids && $firebaseApp) {
      unsubscribeListenToChannelId = await listenToChannelIds((docRef) => {
        if (!docRef.empty) {
          const mappings = docRef.docs.map((d) => ({ ...d.data(), id: d.id }));
          const url = window.location.origin + window.location.pathname;
          ids = getChannelIdFromUrl(url, mappings);
          if (!ids) {
            feedData = null;
          }
        }
      }, $firebaseApp);
    }
  };

  const listenToNewChannelData = async (channelIds) => {
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
      unsubscribeListenToChannel = null;
    }
    if (channelIds.length === 1) {
      unsubscribeListenToChannel = await listenToChannel(
        channelIds[0].id,
        (snapShot) => {
          feedData = snapShot.data();
        },
        $firebaseApp
      );
    } else {
      handleMultipleChannelIds(channelIds);
    }
  };

  const handleMultipleChannelIds = async (channelIds) => {
    channelIds.map(async (id) => {
      await listenToChannel(
        id.id,
        (snapShot) => {
          let channel = snapShot.data();
          if (channel.live) {
            feedData = channel;
          }
        },
        $firebaseApp
      );
    });
  };

  onDestroy(() => {
    if (unsubscribeListenToChannel) {
      unsubscribeListenToChannel();
    }
    if (unsubscribeListenToChannelId) {
      unsubscribeListenToChannelId();
    }
  });
</script>

<style>
  .feed-app {
    width: 100%;
  }
</style>

<main class="feed-app">
  {#if (feedData && feedData.live) || (feedData && show)}
    {#if feedData.scribbleChannel}
      <ScribbleFeeds channel={feedData.scribbleChannel} />
    {:else}
      <FeedContainer title={feedData.title} channel={feedData.feedId} />
    {/if}
  {/if}
</main>
